export const platformOptions = [
  {
    id: "tripadvisor",
    label: "Tripadvisor",
    isSelected: true,
    channel_id: "TRIPADVISOR_META"
  },
  {
    id: "googlehotelads",
    label: "Google Hotel Ads",
    isSelected: true,
    channel_id: "GHA_META"
  },
  {
    id: "googleHotelAdsFBL",
    label: "Google Hotel Ads - FBL",
    isSelected: true,
    channel_id: "GHA_FBL"
  },
  {
    id: "bing",
    label: "Bing Hotel Ads",
    isSelected: true,
    channel_id: "BING"
  },
  {
    id: "trivago",
    label: "Trivago",
    isSelected: true,
    channel_id: "TRIVAGO_META"
  },
  {
    id: "kayak",
    label: "Kayak",
    isSelected: true,
    channel_id: "KAYAK"
  },
  {
    id: "skyScanner",
    label: "Skyscanner",
    isSelected: true,
    channel_id: "SKYSCANNER"
  },
  {
    id: "wego",
    label: "Wego",
    isSelected: true,
    channel_id: "WEGO"
  },
];
export const platformDesignationOptions = [
  {
    id: "googleHotelAdsPropertyPromotionAds",
    label: "Google Hotel Ads - Property Promotion Ads",
    isSelected: true,
    channel_id: "GHA_PPA"
  },
  {
    id: "bingPropertyPromotionAds",
    label: "Bing Hotel Ads - Property Promotion Ads",
    isSelected: true,
    channel_id: "BING_PPA"
  },
  {
    id: "tripadvisorSponsoredPlacement",
    label: "Tripadvisor - Sponsored Placement ",
    isSelected: true,
    channel_id: "TRIPADVISOR_SP"
  },
  {
    id: "trivagoSponsoredListing",
    label: "Trivago Sponsored Listing",
    isSelected: true,
    channel_id: "TRIVAGO_SL"
  },
];

export const hotelOptions = [
  {
    id: "hotel1",
    label: "Hotel Florida",
    isSelected: true,
  },
  {
    id: "hotel2",
    label: "Hotel Petit Beaumarchais",
    isSelected: true,
  },
  {
    id: "hotel3",
    label: "Hotel Domaine du Fontenitelle ",
    isSelected: true,
  },
  {
    id: "hotel4",
    label: "Hotel London West Hollywood",
    isSelected: true,
  },
  {
    id: "hotel5",
    label: "Pierre & Vacances Holiday Village",
    isSelected: true,
  },
  {
    id: "hotel6",
    label: "Hotel London West Hollywood",
    isSelected: true,
  },
  {
    id: "hotel7",
    label: "Hotel London West Hollywood",
    isSelected: true,
  },
  {
    id: "hotel8",
    label: "Hotel Royal Palace",
    isSelected: true,
  },
  {
    id: "hotel9",
    label: "Hotel Grand Central",
    isSelected: false,
  },
  {
    id: "hotel10",
    label: "Hotel Luxe",
    isSelected: true,
  },
  {
    id: "hotel11",
    label: "Hotel Riviera",
    isSelected: false,
  },
  {
    id: "hotel12",
    label: "Hotel Emerald Bay",
    isSelected: true,
  },
  {
    id: "hotel13",
    label: "Hotel Grand Plaza",
    isSelected: false,
  },
  {
    id: "hotel14",
    label: "Hotel Coastal View",
    isSelected: true,
  },
  {
    id: "hotel15",
    label: "Hotel Panorama",
    isSelected: true,
  },
  {
    id: "hotel16",
    label: "Hotel Sunset Ridge",
    isSelected: true,
  },
  {
    id: "hotel17",
    label: "Hotel Alpine Lodge",
    isSelected: false,
  },
  {
    id: "hotel18",
    label: "Hotel Seaside Retreat",
    isSelected: true,
  },
  {
    id: "hotel19",
    label: "Hotel Cityscape",
    isSelected: true,
  },
  {
    id: "hotel20",
    label: "Hotel Mountain Haven",
    isSelected: false,
  },
];

export const groupOptions = [
  {
    id: "openHotels",
    label: "Open hotels",
    isSelected: true,
  },
  {
    id: "closedHotels",
    label: "Closed hotels",
    isSelected: true,
  },
];

export const allPlatformsSegmentOptions = [
  {
    id: "CHANNEL",
    label: "Platform",
    isSelected: true,
  },
  {
    id: "HOTELS",
    label: "Hotels",
    isSelected: true,
  },
  {
    id: "GROUPS",
    label: "Groups",
    isSelected: true,
  },
  {
    id: "DATE",
    label: "Date",
    isSelected: true,
  },
  {
    id: "HOTEL_COUNTRY",
    label: "Hotel Country",
    isSelected: true,
  },
];
export const searchAdsSegmentOptions = [
  {
    id: "DEVICE",
    label: "Device",
    isSelected: true,
  },
  {
    id: "HOTELS",
    label: "Hotels",
    isSelected: true,
  },
  {
    id: "LANG",
    label: "Language",
    isSelected: true,
  },
  {
    id: "DATE",
    label: "Date",
    isSelected: true,
  },
  {
    id: "CAMPAIGN",
    label: "Campaign",
    isSelected: true,
  },
  {
    id: "MARKET",
    label: "Market",
    isSelected: true,
  },
  {
    id: "SEARCH_TERMS",
    label: "Search Terms",
    isSelected: true,
  },
  {
    id: "KEYWORDS",
    label: "Keywords",
    isSelected: true,
  },
    {
    id: "CLICK_TYPE",
    label: "Click Type",
    isSelected: true,
  },
];

export const pMaxSegmentOptions = [
  {
    id: "DEVICE",
    label: "Device",
    isSelected: true,
  },
  {
    id: "HOTELS",
    label: "Hotels",
    isSelected: true,
  },
  {
    id: "LANG",
    label: "Language",
    isSelected: true,
  },
  {
    id: "DATE",
    label: "Date",
    isSelected: true,
  },
  {
    id: "CAMPAIGN",
    label: "Campaign",
    isSelected: true,
  },
  {
    id: "MARKET",
    label: "Market",
    isSelected: true,
  },
];

export const displayAdsSegmentOptions = [
  {
    id: "HOTELS",
    label: "Hotels",
    isSelected: true,
  },
  {
    id: "CAMPAIGN",
    label: "Campaign",
    isSelected: true,
  },
  {
    id: "DATE",
    label: "Date",
    isSelected: true,
  },
];

export const keywordReportingSegmentOptions = [
  {
    id: "DEVICE",
    label: "Device",
    isSelected: true,
  },
  {
    id: "DATE",
    label: "Date",
    isSelected: true,
  },
  {
    id: "HOTELS",
    label: "Hotels",
    isSelected: true,
  },
  {
    id: "CAMPAIGN",
    label: "Campaign",
    isSelected: true,
  },
  {
    id: "KEYWORDS",
    label: "Keywords",
    isSelected: true,
  },
];
export const searchTermReportingSegmentOptions = [
  {
    id: "DEVICE",
    label: "Device",
    isSelected: true,
  },
  {
    id: "DATE",
    label: "Date",
    isSelected: true,
  },
  {
    id: "HOTELS",
    label: "Hotels",
    isSelected: true,
  },
  {
    id: "CAMPAIGN",
    label: "Campaign",
    isSelected: true,
  },
  {
    id: "SEARCH_TERMS",
    label: "Search Terms",
    isSelected: true,
  },
  {
    id: "KEYWORDS",
    label: "Keywords",
    isSelected: true,
  },
];

export const segmentMenuOptions = {
  skyScanner: [
    {
      id: "MARKET",
      label: "Markets",
      isSelected: true,
    },
    {
      id: "DEVICE",
      label: "Device",
      isSelected: true,
    },
    {
      id: "HOTELS",
      label: "Hotels",
      isSelected: true,
    },
    {
      id: "GROUPS",
      label: "Groups",
      isSelected: true,
    },
    {
      id: "DATE",
      label: "Date",
      isSelected: true,
    },
  ],
  trivago: [
    {
      id: "HOTELS",
      label: "Hotels",
      isSelected: true,
    },
    {
      id: "GROUPS",
      label: "Groups",
      isSelected: true,
    },
    {
      id: "MARKET",
      label: "Markets",
      isSelected: true,
    },

    {
      id: "DATE",
      label: "Date",
      isSelected: true,
    },
    {
      id: "LENGTH_OF_STAY",
      label: "Length Of Stay",
      isSelected: true,
    },
    {
      id: "DAY_TO_ARRIVAL",
      label: "Day to Arrival",
      isSelected: true,
    },
    {
      id: "DATE_TYPE",
      label: "Date Type",
      isSelected: true,
    },
    {
      id: "GROUP_SIZE",
      label: "Group Size",
      isSelected: true,
    },
  ],
  tripadvisor: [
    {
      id: "DEVICE",
      label: "Device",
      isSelected: true,
    },
    {
      id: "HOTELS",
      label: "Hotels",
      isSelected: true,
    },
    {
      id: "GROUPS",
      label: "Groups",
      isSelected: true,
    },
    {
      id: "MARKET",
      label: "Markets",
      isSelected: true,
    },
    {
      id: "DATE",
      label: "Date",
      isSelected: true,
    },
    {
      id: "LENGTH_OF_STAY",
      label: "Length Of Stay",
      isSelected: true,
    },
    {
      id: "DAY_TO_ARRIVAL",
      label: "Day to Arrival",
      isSelected: true,
    },
    {
      id: "CHECK_IN_DAY",
      label: "Check in Day",
      isSelected: true,
    },
    {
      id: "DATE_TYPE",
      label: "Date Type",
      isSelected: true,
    },

  ],
  tripadvisorSponsoredPlacement: [
    {
      id: "DEVICE",
      label: "Device",
      isSelected: true,
    },
    {
      id: "HOTELS",
      label: "Hotels",
      isSelected: true,
    },
    {
      id: "GROUPS",
      label: "Groups",
      isSelected: true,
    },
    {
      id: "MARKET",
      label: "Markets",
      isSelected: true,
    },
    {
      id: "DATE",
      label: "Date",
      isSelected: true,
    },
    {
      id: "LENGTH_OF_STAY",
      label: "Length Of Stay",
      isSelected: true,
    },
    {
      id: "DAY_TO_ARRIVAL",
      label: "Day to Arrival",
      isSelected: true,
    },
    {
      id: "GROUP_SIZE",
      label: "Group Size",
      isSelected: true,
    },
    {
      id: "DATE_TYPE",
      label: "Date Type",
      isSelected: true,
    },
  ],
  trivagoSponsoredListing: [
    {
      id: "DEVICE",
      label: "Device",
      isSelected: true,
    },
    {
      id: "HOTELS",
      label: "Hotels",
      isSelected: true,
    },
    {
      id: "GROUPS",
      label: "Groups",
      isSelected: true,
    },
    {
      id: "MARKET",
      label: "Markets",
      isSelected: true,
    },
    {
      id: "DATE",
      label: "Date",
      isSelected: true,
    },
    {
      id: "LENGTH_OF_STAY",
      label: "Length Of Stay",
      isSelected: true,
    },
    {
      id: "DAY_TO_ARRIVAL",
      label: "Day to Arrival",
      isSelected: true,
    },
    {
      id: "GROUP_SIZE",
      label: "Group Size",
      isSelected: true,
    },
    {
      id: "DATE_TYPE",
      label: "Date Type",
      isSelected: true,
    },
  ],
  googlehotelads: [
    {
      id: "DEVICE",
      label: "Device",
      isSelected: true,
    },
    {
      id: "HOTELS",
      label: "Hotels",
      isSelected: true,
    },
    {
      id: "GROUPS",
      label: "Groups",
      isSelected: true,
    },
    {
      id: "MARKET",
      label: "Markets",
      isSelected: true,
    },
    {
      id: "DATE",
      label: "Date",
      isSelected: true,
    },
    {
      id: "LENGTH_OF_STAY",
      label: "Length Of Stay",
      isSelected: true,
    },
    {
      id: "DAY_TO_ARRIVAL",
      label: "Day to Arrival",
      isSelected: true,
    },
    {
      id: "CHECK_IN_DAY",
      label: "Check in Day",
      isSelected: true,
    },
    {
      id: "PRICE_COMPETITIVENESS",
      label: "Price Competitiveness",
      isSelected: true,
    },
    {
      id: "DATE_TYPE",
      label: "Date Type",
      isSelected: true,
    },
  ],
  googleHotelAdsPropertyPromotionAds: [
    {
      id: "DEVICE",
      label: "Device",
      isSelected: true,
    },
    {
      id: "HOTELS",
      label: "Hotels",
      isSelected: true,
    },
    {
      id: "GROUPS",
      label: "Groups",
      isSelected: true,
    },
    {
      id: "MARKET",
      label: "Markets",
      isSelected: true,
    },
    {
      id: "DATE",
      label: "Date",
      isSelected: true,
    },
    {
      id: "LENGTH_OF_STAY",
      label: "Length Of Stay",
      isSelected: true,
    },
    {
      id: "DAY_TO_ARRIVAL",
      label: "Day to Arrival",
      isSelected: true,
    },
    {
      id: "CHECK_IN_DAY",
      label: "Check in Day",
      isSelected: true,
    },
    {
      id: "PRICE_COMPETITIVENESS",
      label: "Price Competitiveness",
      isSelected: true,
    },
    {
      id: "DATE_TYPE",
      label: "Date Type",
      isSelected: true,
    },
  ],
  googleHotelAdsFBL: [
    {
      id: "DEVICE",
      label: "Device",
      isSelected: true,
    },
    {
      id: "HOTELS",
      label: "Hotels",
      isSelected: true,
    },
    {
      id: "GROUPS",
      label: "Groups",
      isSelected: true,
    },
    {
      id: "MARKET",
      label: "Markets",
      isSelected: true,
    },
    {
      id: "HOTEL_COUNTRY",
      label: "Hotel Country",
      isSelected: true,
    },
  ],
  bing: [
    {
      id: "BING_SITE",
      label: "Bing Site",
      isSelected: true,
    },
    {
      id: "DEVICE",
      label: "Device",
      isSelected: true,
    },
    {
      id: "HOTELS",
      label: "Hotels",
      isSelected: true,
    },
    {
      id: "GROUPS",
      label: "Groups",
      isSelected: true,
    },
    {
      id: "MARKET",
      label: "Markets",
      isSelected: true,
    },
    {
      id: "DATE",
      label: "Date",
      isSelected: true,
    },
    {
      id: "LENGTH_OF_STAY",
      label: "Length Of Stay",
      isSelected: true,
    },
    {
      id: "CHECK_IN_DAY",
      label: "Check in Day",
      isSelected: true,
    },
  ],
  bingPropertyPromotionAds: [
    {
      id: "BING_SITE",
      label: "Bing Site",
      isSelected: true,
    },
    {
      id: "DEVICE",
      label: "Device",
      isSelected: true,
    },
    {
      id: "HOTELS",
      label: "Hotels",
      isSelected: true,
    },
    {
      id: "GROUPS",
      label: "Groups",
      isSelected: true,
    },
    {
      id: "MARKET",
      label: "Markets",
      isSelected: true,
    },
    {
      id: "DATE",
      label: "Date",
      isSelected: true,
    },
    {
      id: "LENGTH_OF_STAY",
      label: "Length Of Stay",
      isSelected: true,
    },
    {
      id: "CHECK_IN_DAY",
      label: "Check in Day",
      isSelected: true,
    },
  ],
  kayak: [
    {
      id: "DEVICE",
      label: "Device",
      isSelected: true,
    },
    {
      id: "MARKET",
      label: "Markets",
      isSelected: true,
    },
    {
      id: "HOTELS",
      label: "Hotels",
      isSelected: true,
    },
    {
      id: "GROUPS",
      label: "Groups",
      isSelected: true,
    },

    {
      id: "DATE",
      label: "Date",
      isSelected: true,
    },
    {
      id: "LENGTH_OF_STAY",
      label: "Length Of Stay",
      isSelected: true,
    },
    {
      id: "DAYS_TO_ARRIVAL",
      label: "Days to Arrival",
      isSelected: true,
    },
    {
      id: "WEEK_END_STAY",
      label: "Week-end Stay",
      isSelected: true,
    },
  ],
  wego: [
    {
      id: "DATE",
      label: "Date",
      isSelected: true,
    },
   
    {
      id: "HOTELS",
      label: "Hotels",
      isSelected: true,
    },
    {
      id: "GROUPS",
      label: "Groups",
      isSelected: true,
    },
  ],
};

export const aiConnectSegmentOptions = [ 
    {
      id: "HOTEL_COUNTRY",
      label: "Hotel Country",
      isSelected: true,
    }, 
    {
      id: "HOTELS",
      label: "Hotels",
      isSelected: true,
    },
    {
      id: "GROUPS",
      label: "Groups",
      isSelected: true,
    },
    {
      id: "DATE",
      label: "Date",
      isSelected: true,
    },
    {
      id: "AI_SOURCE",
      label: "AI Connect",
      isSelected: true,
    },
]

export const metaTravelAdsSegmentOptions = [
  {
    id: "HOTELS",
    label: "Hotels",
    isSelected: true,
  },
  {
    id: "DATE",
    label: "Date",
    isSelected: true,
  },
  {
    id: "CAMPAIGN",
    label: "Campaign",
    isSelected: true,
  },
  {
    id: "MARKET",
    label: "Markets",
    isSelected: true,
  },
  {
    id: "DEVICE",
    label: "Device",
    isSelected: true,
  },
  {
    id: "PLATFORM",
    label: "Platform",
    isSelected: true,
  }
]
